export interface DeleteFileProps {
  urlSlug: string;
  fileName: string;
  publicId?: string;
  isSigner?: boolean;
  trackingId?: string;
}

export const deleteFile = async ({
  urlSlug,
  fileName,
  publicId,
  isSigner,
  trackingId,
}: DeleteFileProps): Promise<void> => {
  let url: string;

  if (trackingId) {
    // Trade references flow
    if (!trackingId || !urlSlug) {
      throw new Error('Cannot remove files before submission is created and trackingId is provided');
    }
    url = `${process.env.REACT_APP_API_URL}/trade-references/${urlSlug}/${trackingId}/files/${fileName}`;
  } else if (publicId) {
    // Submission flow
    if (!publicId || !urlSlug) {
      throw new Error('Cannot remove files before submission is created');
    }
    url = `${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/files/${fileName}?isSigner=${isSigner || false}`;
  } else {
    throw new Error('Either trackingId or publicId must be provided');
  }

  const response = await fetch(url, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to delete file: ${response.statusText}`);
  }
};
